import games from '../../api/games'
import Vue from 'vue'


const state = {
    games: []
}

const getters = {
    activeGameCount: state => {
        return state.games.filter(game => !game.completed).length
    },
    activeGames: state => {
        return state.games.filter(game => !game.completed)
    },
    completedGames: state => {
        return state.games.filter(game => game.completed)
    },
    getGame: (state) => (id) => {
        return state.games.filter(game => game.id === id)[0]
    }
}

const mutations = {
    setGames(state, data) {
        state.games = data
    },
    addGame(state, game) {
        state.games.push(game)
    },
    removeGame(state, id) {
        for (let i = 0; i < state.games.length; i++) {
            if (state.games[i].id === id) {
                state.games.splice(i, 1);
            }
        }
    },
    updateGame(state, updatedGame) {
        const gameToUpdate = state.games.filter(game => game.id === updatedGame.id)[0];
        Vue.set(gameToUpdate, 'completedRounds', updatedGame.completedRounds)
        Vue.set(gameToUpdate, 'currentRound', updatedGame.currentRound)
        Vue.set(gameToUpdate, 'currentScores', updatedGame.currentScores)
        Vue.set(gameToUpdate, 'rounds', updatedGame.rounds)
        Vue.set(gameToUpdate, 'playerTurn', updatedGame.playerTurn)
        Vue.set(gameToUpdate, 'completed', updatedGame.completed)
        Vue.set(gameToUpdate, 'winner', updatedGame.winner)
    }
}

const actions = {
    /* eslint-disable no-console */
    selectGame({ commit }, data) {
        console.log('selecting game with id ' + data.id)
        const game = state.games.filter(game => game.id === data.id)[0]
        if (!game) {
            console.log('no game ' + data.id)
        }
        else {
            commit('game/setGameSummary', { game: game }, { root: true })
        }
    },
    retrieveGames({ commit }) {
        games.retrieveGames(response => {
            commit('setGames', response); // JSON are parsed automatically.
        }, e => {
            console.log(e);
        });
    },
    deleteGame({ commit }, id) {
        games.deleteGame(id, () => {
            commit('removeGame', id);
        }, e => {
            console.log(e);
        });
    },
    newGame({ commit }, data) {
        return new Promise((resolve, reject) => {
            games.newGame(data, response => {
                commit('addGame', response);
                resolve(response)
            }, e => {
                reject(e);
            });
        });
    },
    updateScore({ commit }, data) {
        return new Promise((resolve, reject) => {
            games.updateScore(data.id, data, response => {
                games.getGame(data.id, response => {
                    commit('updateGame', response)
                    resolve(response)
                });
                resolve(response)
            }, e => {
                reject(e);
            });
        });
    }
    /* eslint-enable no-console */
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}